import React from "react";
import { Container } from "react-bootstrap";
import "./page-header.css";

const PageHeader = ({ title }) => {
  return (
    <div className="page-header" style={{ padding: `100px 0px` }}>
      <Container>
        <h1>{title}</h1>
      </Container>
    </div>
  );
};

export default PageHeader;
